export enum AbilityLimitStatus {
  OnlyTurkishAirlines = 0,
  ThirdPartyOk = 1,
}
